import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import useQualtrics from "./hooks/useQualtrics";
import useShowQTXSurvey from "./hooks/useShowQTXSurvey";
import { Redirect } from 'react-router-dom'
import { MyChartHeading } from "../ecosystem/mybswh";

const Echeckin = (props) => {
    const [showQTXSurvey, setShowQTXSurvey] = useState(false);
    const [childFrameData, setChildFrameData] = useState({});
    const bswMatch = ".card.helptip.success";
    const observe = "div#content";
    const enableSurvey = window.serverData.data.enableQualtricsSurveyECheckin;
    const events = [{ elements: ".card", eventName: "click", message: "childFrameChanged" }];
    const { hasMyChart, serverData } = props;
    const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling ? serverData.enableCustomDirectScheduling : false;
    const eCheckInBaseUrl = serverData && serverData.myChartBaseUrl ? serverData.myChartBaseUrl : "";
    const encodedCSN = props.location.state && props.location.state.csnId ? encodeURIComponent(props.location.state.csnId) : "";
    const modeString = "Echeckin&csn=" + encodedCSN;

    useEffect(() => {
        logUI("MBHWeb.UI.EcheckIn.ComponentDidMount", new Date(), Tools.getURLPath());
    }, []);

    useEffect(() => {
        const shouldShowQTXSurvey = useShowQTXSurvey(enableSurvey, childFrameData, bswMatch);
        if (shouldShowQTXSurvey) {
            setShowQTXSurvey(true);
        }
        return () => { console.info(`Echeckin childFrameData clean up.`); };
    }, [childFrameData]);

    useQualtrics(showQTXSurvey);

    const headingCTAPath = hasMyChart
        ? enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "/schedulingFor"
        : "/findcare";
    const heading = <MyChartHeading
        heading="Appointments and Visits"
        headingButton={{
            label: "Schedule an Appointment",
            to: { pathname: headingCTAPath }
        }}
    />;

    if (encodedCSN == "") {
        //debugger;
        return <Redirect to='/' />
    }
    else {
        return (
            <MyChartContainer mode={modeString} title="Appointments and Visits" heading={heading} showQTXSurvey={showQTXSurvey}
                events={events} bswMatch={bswMatch} observe={observe}
                onObserved={(data) => { setChildFrameData(data); }}
                onMessage={doEventMatch} />
        );
    }
 

}
const doEventMatch = (event) => {
    console.info('Echeckin doEventMatch ', event);
}
const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        serverData: state.session.serverData
    };
};



export default withRouter(connect(mapStateToProps)(Echeckin));